export default {"src":"/_next/static/media/Fiona _small_logo.06c227d1.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};